import gql from "graphql-tag";

export const MY_HR_GET_COMPANIES = gql`
  query companies(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
  ) {
    companies(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      total
      rows {
        _id
        code
        name
        companyLogo
      }
      page
      pageSize
      totalPages
    }
  }
`;
